function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M44 4H4a4 4 0 00-4 4v26.67a4 4 0 004 4h16l-1.33 4h-6a2 2 0 00-2 2c0 1.1.89 2 2 2h22.66a2 2 0 002-2 2 2 0 00-2-2h-6l-1.33-4h16a4 4 0 004-4V8a4 4 0 00-4-4zm-1.33 29.33H5.33v-24h37.34v24z"
})));